/* eslint-disable */
import Portal from "react-overlays/esm/Portal";
import { useDispatch, useSelector } from "react-redux";
import styles from "./AppFeedback.module.scss";
import Feedback1 from "../assets/images/feedback_1.png";
import Feedback2 from "../assets/images/feedback_2.png";
import Feedback3 from "../assets/images/feedback_3.png";
import Feedback4 from "../assets/images/feedback_4.png";
import Feedback5 from "../assets/images/feedback_5.png";
import { apiGetAppFeedback, apiSubmitAppFeedback } from "../helpers/api";
import { successToast } from "../helpers/toastHelper";
import { useEffect } from "react";
import { useUserContext } from "../contexts/UserContext";
import {
  gamifyBoardingActions,
  selectAppFeedbackAttempts,
  selectAppFeedbackEnabled,
} from "../redux/slicers/gamifySlicer";
import { BeforeUnload } from "./BeforeUnload";
import { showHideTooltip } from "../components/gamificationTooltip/helpers";
import { Mixpanel, MxEvent } from "./Mixpanel";
import { isMattressBuilderPage } from "../components/admin/curator/ProductBuilderComponents/commonHelper";

const FEEDBACK = {
  VERY_DIFFICULT: 1,
  DIFFICULT: 2,
  AVERAGE: 3,
  EASY: 4,
  VERY_EASY: 5,
};

export const AppFeedback = () => {
  const FEEDBACKS = [
    {
      id: FEEDBACK.VERY_DIFFICULT,
      thumbnail: Feedback1,
      title: "Very Difficult",
    },
    { id: FEEDBACK.DIFFICULT, thumbnail: Feedback2, title: "Difficult" },
    { id: FEEDBACK.AVERAGE, thumbnail: Feedback3, title: "Average" },
    { id: FEEDBACK.EASY, thumbnail: Feedback4, title: "Easy" },
    { id: FEEDBACK.VERY_EASY, thumbnail: Feedback5, title: "Very Easy" },
  ];

  const dispatch = useDispatch();
  const { currentUser, updateUserData } = useUserContext();
  const askFeedback = useSelector(selectAppFeedbackEnabled);
  const feedbackAttempts = useSelector(selectAppFeedbackAttempts);
  const attempts = Number(feedbackAttempts);

  useEffect(async () => {
    if (!currentUser) return;
    if (isMattressBuilderPage()) return;
    const res = await apiGetAppFeedback();
    if (res && res?.results.length) {
      const feedback = res?.results?.[0];
      if (!document.hidden && !feedback) {
        dispatch(gamifyBoardingActions.showAppFeedback());
      }
    }
  }, []);

  const handleFeedback = async (id) => {
    const res = await apiSubmitAppFeedback({ feedback: id });
    if (res && res?.status) {
      successToast("Thanks for your valuable feedback.");
      dispatch(gamifyBoardingActions.closeAppFeedback());
      const showTooltip =
        "showTemplateTooltip" in currentUser?.user?.other_info ? false : true;
      const obj = {
        gamifyOnBoarding: {
          ...currentUser?.other_info?.gamifyOnBoarding,
        },
        showTemplateTooltip: showTooltip,
        isFeedbackGiven: true,
      };
      showHideTooltip(currentUser, updateUserData, obj);
      Mixpanel.track(true, MxEvent.GAMIFY_ONBOARDING_RATED, {
        "Onboarding rating": id,
      });
   }
  };

  if (
    !askFeedback ||
    currentUser?.user?.other_info?.isFeedbackGiven ||
    attempts > 3
  )
    return null;

  return (
    <Portal>
      <BeforeUnload
        onBeforeunload={() =>
          dispatch(gamifyBoardingActions.closeAppFeedback())
        }
      />
      <div className={styles.feedback}>
        <h2 className={styles.title}>
          How would you rate your
          <br />
          experience ?
        </h2>
        <div className={styles.feedbackIcon}>
          <ul className={styles.icons}>
            {FEEDBACKS.map(({ id, thumbnail, title }) => (
              <li>
                <img
                  className={styles.icon}
                  title={title}
                  onClick={() => handleFeedback(id)}
                  src={thumbnail}
                />
              </li>
            ))}
          </ul>
          <p className={styles.message}>
            <span>Very Difficult</span>
            <span>Very Easy</span>
          </p>
        </div>
      </div>
    </Portal>
  );
};
